import React from 'react';
import { makeStyles } from '@material-ui/core';
import udafLogo from 'img/udaf-logo.svg';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    width: '57px',
  },
  content: {
    paddingLeft: '10px',
    '& h1': {
      fontStyle: 'italic',
      color: theme.custom.primary,
      lineHeight: '1.15em',
    },
    '& h1, & h2': {
      fontSize: '1em',
      margin: '0',
    },
    '& address, & p': {
      fontSize: '0.813em',
      margin: '0',
      fontStyle: 'normal',
    },
  },
  contact: {
    display: 'flex',
    '& > p': {
      width: '50%',
    },
  },
}));

const Header = () => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <img src={udafLogo} alt="Utah Brands" className={classes.logo} />
      <div className={classes.content}>
        <h1>Lifetime Horse Travel Permit</h1>
        <h2>Utah Department of Agriculture and Food</h2>
        <address>PO Box 146500, Salt Lake City, Utah 84114-6500</address>
        <div className={classes.contact}>
          <p>Phone: (801) 538-7137</p>
          <p>Web: http://ag.utah.gov</p>
        </div>
      </div>
    </div>
  );
};

export default Header;
